// 商品左上角标签
import "./index.less";

export const renderCouponLabel = ({
  couponLabel,
  discountType = '',
  isActive = true,
  countdown = "",
}) => {
  const isSeckill = discountType === "SECONDS_KILL_PRICE";
  if (!couponLabel) {
    return null;
  }
  return (
    <div className={`coupon-pack-tag ${isActive && "active"}`}>
      <div className={`coupon-pack-discount-tag ${isSeckill && "seckill"}`}>
        <div className="discount-tag-text">
          {couponLabel}
          {isSeckill && countdown ? <span className="discount-sekill-count-down">剩余{countdown}</span> : null}
        </div>
      </div>
      {isSeckill && <div className="seckill-icon" />}
    </div>
  );
};
